import Service from "@/utils/api/service";
import Media from "@/components/share/media";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "EditPopupBanner",
  data() {
    return {
      isFetching: true,
      isCreating: false,
      display: {
        mobile: {
          schedule: false,
          media: false,
          imagePreview: false,
        },
        web: {
          schedule: false,
          media: false,
          imagePreview: false,
        },
      },
      body: {
        title: "",
        description: "",
        pushAt: "",
        webImageUrl: "",
        webRedirectLink: "",
        appImageUrl: "",
        appRedirectLink: "",
        hideAfterSecond: 0,
        showAfterSecond: 0,
        customerIds: [],
        customerGroupIds: [],

        // custom field
        isMobile: true,
        isWeb: true,
        type: 1,
        isAutoClose: false,
        status: "active",
      },
      payload: {},
      popupTypes: [
        { id: 1, name: "Immediately" },
        { id: 2, name: "After second" },
      ],
      mobile: {
        media: "",
      },
      web: {
        media: "",
      },

      models: {
        time: "",
        date: "",
      },
      customToolbarSpecification: [
        ["bold", "italic", "underline"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        ["link"],
      ],

      loading: {
        isCreating: false,
        isSearching: false,
      },
      customers: [],
      customerGroups: this.$master?.customerGroups || [],
      allCustomerGroups: this.$master?.customerGroups || [],
      isDescription: true,
    };
  },
  components: {
    Media,
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
    debouncedOnSearchCustomers() {
      return _debounce(this.searchCustomers, 500);
    },
    debouncedOnSearchCustomerGroups() {
      return _debounce(this.searchCustomerGroups, 500);
    },
    customerOptions() {
      return this.customers.map((c) => ({
        ...c,
        displayName: c?.bpName
          ? `${c?.bpName} ( ${c?.code} )`
          : !c.firstName && !c.lastName && c?.bpName
          ? `${c?.bpName} ( ${c?.code} )`
          : `${c?.firstName || ""} ${c?.lastName || ""} ( ${c?.code} )`.trim(),
      }));
    },
    customerGroupOptions() {
      return this.customerGroups.map((c) => ({
        ...c,
        displayName: `${c.name || ""}`.trim(),
      }));
    },
  },
  created() {
    this.getPopupBanner();

    setTimeout(() => {
      this.searchCustomers();
      this.searchCustomerGroups();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListPopupBanner",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getPopupBanner() {
      Service.getPopupBanner(this.$route.query.id).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getPopupBanner();
              }
            });
          } else {
            this.isDescription = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.body = {
            title: response.data?.title || "",
            description: response.data?.description || "",
            pushAt: new Date(response.data.pushAt).toISOString().slice(0, 16),
            webImageUrl: response.data?.webImageUrl || "",
            webRedirectLink: response.data?.webRedirectLink || "",
            appImageUrl: response.data?.appImageUrl || "",
            appRedirectLink: response.data?.appRedirectLink || "",
            hideAfterSecond: response.data?.hideAfterSecond,
            showAfterSecond: response.data?.showAfterSecond,
            customerIds: response.data?.customerIds || [],
            customerGroupIds: response.data?.customerGroupIds || [],

            // custom field
            isMobile: response.data?.appImageUrl ? true : false,
            isWeb: response.data?.webImageUrl ? true : false,
            type: response.data?.showAfterSecond > 0 ? 2 : 1,
            isAutoClose: response.data?.hideAfterSecond > 0 ? true : false,
            status: response?.data?.status,
          };

          if (
            response?.data?.customerGroups &&
            response?.data?.customerGroups.length
          ) {
            this.body.customerGroupIds = response?.data?.customerGroups.map(
              (c) => ({
                ...c,
                displayName: `${c?.name || ""}`.trim(),
              })
            );
          }

          if (response?.data?.customers && response?.data?.customers.length) {
            this.body.customerIds = response?.data?.customers.map((c) => ({
              ...c,
              displayName: c?.bpName
                ? `${c?.bpName} ( ${c?.code} )`
                : !c.firstName && !c.lastName && c?.bpName
                ? `${c?.bpName} ( ${c?.code} )`
                : `${c?.firstName || ""} ${c?.lastName || ""} ( ${
                    c?.code
                  } )`.trim(),
            }));
          }

          if (response.data.webImageUrl) {
            this.web.media = {
              fileName: this.getNameFromUrl(response.data.webImageUrl),
              url: response.data.webImageUrl,
            };
          }
          if (response.data.appImageUrl) {
            this.mobile.media = {
              fileName: this.getNameFromUrl(response.data.appImageUrl),
              url: response.data.appImageUrl,
            };
          }

          this.payload = {
            title: response.data?.title || "",
            description: response.data?.description || "",
            pushAt: new Date(response.data.pushAt).toISOString().slice(0, 16),
            webImageUrl: response.data?.webImageUrl || "",
            webRedirectLink: response.data?.webRedirectLink || "",
            appImageUrl: response.data?.appImageUrl || "",
            appRedirectLink: response.data?.appRedirectLink || "",
            hideAfterSecond: response.data?.hideAfterSecond,
            showAfterSecond: response.data?.showAfterSecond,
            customerIds: response.data?.customerIds || [],
            customerGroupIds: response.data?.customerGroupIds || [],

            // custom field
            isMobile: response.data?.appImageUrl ? true : false,
            isWeb: response.data?.webImageUrl ? true : false,
            type: response.data?.showAfterSecond > 0 ? 2 : 1,
            isAutoClose: response.data?.hideAfterSecond > 0 ? true : false,
            status: response?.data?.status,
          };
          this.isDescription = false;
        }

        this.isFetching = false;
      });
    },

    timestampFormat(date, delimiter) {
      let hours = date.getHours();
      const minutes = ("00" + date.getMinutes()).slice(-2);
      hours = (date.getHours() - 7) % 12;
      hours = ("00" + hours).slice(-2);
      let time = hours.toString();

      const timestamp = [time.replace("-", "0"), minutes].join(
        delimiter || ":"
      );
      return [timestamp].join(" ");
    },

    // search
    async searchCustomers(query) {
      if (!this.checkoutPermission("LIST_CUSTOMER_ACCOUNT")) return;

      this.loading.isSearching = true;
      let search = { search: query };
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        status: "active",
        ...search,
      });
      let params = this.$helper.queryParam(setQuery);

      await Service.getCustomers(params).then((response) => {
        this.loading.isSearching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.searchCustomers();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.customers = response?.data;
        }
      });
    },

    searchCustomerGroups(query) {
      if (!query || query.trim() === "") {
        this.customerGroups = [...this.allCustomerGroups];
        return;
      }

      this.filterCustomerGroup(this.allCustomerGroups, query);
    },

    filterCustomerGroup(data, search) {
      if (!search || search.trim() === "") {
        this.customerGroups = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.customerGroups = items;
    },

    // mobile image
    removeMobileMedia() {
      this.mobile.media = "";
      this.body.appImageUrl = "";
    },
    closeMobileModal() {
      this.display.mobile.media = false;
      this.display.mobile.imagePreview = false;
    },

    imageMobilePreview() {
      if (this.mobile.media != "") {
        this.display.mobile.imagePreview = true;
      }
    },
    chooseMobileImage() {
      this.display.mobile.media = true;
    },

    existedMobileMediaCallback(media) {
      this.mobile.media = media;
      this.body.appImageUrl = media.url;
      this.closeMobileModal();
    },

    // web image
    removeWebMedia() {
      this.web.media = "";
      this.body.webImageUrl = "";
    },
    closeWebModal() {
      this.display.web.media = false;
      this.display.web.imagePreview = false;
    },

    imageWebPreview() {
      if (this.web.media != "") {
        this.display.web.imagePreview = true;
      }
    },
    chooseWebImage() {
      this.display.web.media = true;
    },

    existedWebMediaCallback(media) {
      this.web.media = media;
      this.body.webImageUrl = media.url;
      this.closeWebModal();
    },
    // end image

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    onSubmit() {
      let validatedMessage = this.validateBody(this.body);

      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.title) {
        return "Title cannot be empty!";
      }

      if (!data.isMobile && !data.isWeb) {
        return "Mobile App Or Web Browser must be select!";
      }

      if (data?.isMobile) {
        if (!this.mobile?.media?.url) {
          return "Mobile App image cannot be empty!";
        }
        // else if (!data?.appRedirectLink) {
        //   return "Display On is invalid!";
        // }
      }

      if (data?.isWeb) {
        if (!this.web?.media?.url) {
          return "Web Browser image cannot be empty!";
        }
        // else if (!data?.webRedirectLink) {
        //   return "Display On is invalid!";
        // }
      }

      if (!data.pushAt) {
        return "Schedule cannot be empty!";
      }

      if (this.payload.pushAt) {
        if (this.payload.pushAt !== this.body.pushAt) {
          if (data.pushAt) {
            const now = new Date();
            const pushAt = new Date(data.pushAt);

            if (isNaN(pushAt.getTime())) {
              return "Invalid Schedule date!";
            }

            if (pushAt < now) {
              return "Schedule cannot be earlier than the current time!";
            }
          }
        }
      } else {
        if (data.pushAt) {
          const pad = (n) => n.toString().padStart(2, "0");
          const now = new Date();
          const localISO = `${now.getFullYear()}-${pad(
            now.getMonth() + 1
          )}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(
            now.getMinutes()
          )}:${pad(now.getSeconds())}.000Z`;

          const pushAt = new Date(data?.pushAt);

          if (isNaN(pushAt.getTime())) {
            return "Invalid Schedule date!";
          }

          if (data?.pushAt < localISO) {
            return "Schedule cannot be earlier than the current time!";
          }
        }
      }

      return "ok";
    },

    onConfirm() {
      const body = {
        title: this.body.title || "",
        description: this.body.description || "",
        pushAt: (this.body.pushAt && this.body.pushAt + ":00.000Z") || "" || "",
        webImageUrl: (this.body.isWeb && this.body.webImageUrl) || "",
        webRedirectLink: (this.body.isWeb && this.body.webRedirectLink) || "",
        appImageUrl: (this.body.isMobile && this.body.appImageUrl) || "",
        appRedirectLink:
          (this.body.isMobile && this.body.appRedirectLink) || "",
        hideAfterSecond:
          (this.body.isAutoClose && Number(this.body.hideAfterSecond)) ||
          0 ||
          0,
        showAfterSecond:
          (this.body.type === 2 && Number(this.body.showAfterSecond)) || 0 || 0,
        customerIds: Array.isArray(this.body.customerIds)
          ? this.body.customerIds.map((item) => item.id)
          : [],
        customerGroupIds: Array.isArray(this.body.customerGroupIds)
          ? this.body.customerGroupIds.map((item) => item.id)
          : [],

        status: this.body.status,
      };

      Service.updatePopupBanner(this.$route.query.id, body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.onConfirm();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isCreating = false;
          this.resetBody();
          this.$toasted.show("Popup Banner has been updated.");
          this.goBack();
        }
      });
    },

    resetBody() {
      this.body = {
        title: "",
        description: "",
        pushAt: "",
        webImageUrl: "",
        webRedirectLink: "",
        appImageUrl: "",
        appRedirectLink: "",
        hideAfterSecond: 10,
        showAfterSecond: 3,
        customerIds: [],
        customerGroupIds: [],

        // custom field
        isMobile: false,
        isWeb: false,
        type: 1,
        isAutoClose: false,
        status: "active",
      };
      this.mobile.media = "";
      this.web.media = "";
      this.display = {
        mobile: {
          schedule: false,
          media: false,
          imagePreview: false,
        },
        web: {
          schedule: false,
          media: false,
          imagePreview: false,
        },
      };
    },
  },
};
